import { render, staticRenderFns } from "./DashboardUsuario.vue?vue&type=template&id=0881a54f&scoped=true"
import script from "./DashboardUsuario.vue?vue&type=script&lang=js"
export * from "./DashboardUsuario.vue?vue&type=script&lang=js"
import style0 from "./DashboardUsuario.vue?vue&type=style&index=0&id=0881a54f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0881a54f",
  null
  
)

export default component.exports